module.exports = __webpack_public_path__ + "img/hs-02.7d161b78.svg";